import { render, staticRenderFns } from "./DashboardConversation.vue?vue&type=template&id=fa680b70&scoped=true"
import script from "./DashboardConversation.vue?vue&type=script&lang=js"
export * from "./DashboardConversation.vue?vue&type=script&lang=js"
import style0 from "./DashboardConversation.vue?vue&type=style&index=0&id=fa680b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa680b70",
  null
  
)

export default component.exports